<template>
  <section class="quotewizard">
    <loader :loading="loading"></loader>
    <div class="container purchasesummary-end">
      <br /><br /><br />
      <div class="title" style="text-align: center; color: #333">
        Purchase Summary
      </div>
      <p style="text-align: center; margin-top: 4px; line-height: 22px">
        We'll email you a confirmation of your policy.
      </p>
      <br /><br />
      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="mobilecollpasetable"
      >
        <tbody>
          <tr>
            <td width="48%" valign="top" class="success">
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td width="20%" valign="top">
                      <span class="bigsuccess-checkmark"></span>
                    </td>
                    <td valign="top">
                      <strong>Your Renters Insurance</strong>
                      <ul>
                        <li>Property Damage &amp; Personal Liability<br /></li>
                        <li>Personal Property Coverage<br /></li>
                      </ul>
                      <b>Success! You're Covered.</b>
                      <br />
                      <br />
                      <span
                        style="color: #777; font-size: 13px; line-height: 18px"
                        ><b>Bank Statement Notice:</b><br />
                        Transaction may appear as "AGI* Renters/Condo
                        Ins".</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td valign="top" class="error">
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td width="20%" valign="top">
                      <span class="bigerror-x"></span>
                    </td>
                    <td valign="top">
                      <strong>
                        Your Personal Property Accidental Damage Coverage Add-On
                      </strong>
                      <div class="try">
                        <em>Things you can try...</em>
                        <br />
                        <ul>
                          <li>
                            <a href="#" @click="retryPersonal()">Retry</a>
                            transaction
                          </li>
                          <li v-if="quote.personalInsurance.hasPaymentErrors">
                            Try a
                            <a
                              class="javascriptlink"
                              @click.prevent="showChangePaymentInfoModal()"
                              >different payment method,
                            </a>
                          </li>
                          <li>
                            Visit
                            <a
                              href="https://www.nssi.com/individual-quote"
                              target="_blank"
                              >NSSI.com
                            </a>
                            to purchase
                          </li>
                          <li>
                            <a
                              href="https://www.nssi.com/contact-us"
                              target="_blank"
                              >Contact NSSI
                            </a>
                            for help or to report an issue
                          </li>
                        </ul>
                      </div>
                      <b>Failed! You're <u>NOT</u> covered for accidents!</b
                      ><br />
                      <small style="line-height: 15px">{{ errorMsg }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <br /><br />
      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="gold notice"
      >
        <tbody>
          <tr>
            <td>
              <button target="_blank" @click="generateOrderPdf">
                View your order receipt (PDF)
              </button>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <button target="_blank" @click="generateApplicationPdf">
                View your application (PDF)
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <table
        width="100%"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="notice"
      >
        <tbody>
          <tr>
            <td>
              To manage your Renters Insurance policy, use
              <a href="https://manage.myassurantpolicy.com/" target="_blank"
                >MyAssurantPolicy</a
              >.
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <p style="text-align: center; line-height: 22px">
        <router-link :to="{ name: 'home' }" @click="clearQuote()"
          >Return to homepage</router-link
        >
      </p>
    </div>
    <change-payment-info-modal
      ref="changePaymentInfo"
      @payment-changed="onPaymentMethodChanged"
    ></change-payment-info-modal>
  </section>
</template>

<script lang="ts" setup>
import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import { EmailService } from "@/api/EmailService";
import ChangePaymentInfoModal from "@/views/modals/context/ChangePaymentInfoModal.vue";
import Modals from "@/utils/Modals";
// import ChangePaymentInfoModal from "@/views/modals/ChangePaymentInfoModal.vue";
import { PaymentMethod } from "@/models/PaymentMethod";
import { ReceiptService } from "@/api/ReceiptService";
//import { getReceipts } from "@/services/Functions";
import { onMounted, ref, computed, Ref } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";

const loading: Ref<boolean> = ref(false);
const applicationPdfLink = ref("");
const orderLink = ref("");
const changePaymentInfo = ref(null);
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;
const modals: Array<Modals> = [];

const getReceipt = async () => {
  //TODO get links and re usable function
  const response = await ReceiptService.getReceiptLink(quote);
  if (response.error === false) {
    applicationPdfLink.value = response.result.application_pdf_link;
    orderLink.value = response.result.order_link;
  }
};

//This function is not used
// function goToPage(command: string) {
//   quote.setQuoteStep(command);
// }

onMounted(async () => {
  if (!quote.folowUpMailSent) {
    await getReceipt();
    quote.nssiPassed = false;
    quote.folowUpMailSent = true;
    await EmailService.sendOrderReceipt(
      quote,
      user,
      applicationPdfLink.value,
      orderLink.value
    );
  }
});

const errorMsg = computed(() => {
  if (quote.personalInsurance.hasPaymentErrors) {
    return quote.nssiPolicyError;
  } else {
    return "Something went wrong. Please try again.";
  }
});
const checkDone = async () => {
  if (quote.assurantPassed && quote.nssiPassed) {
    quote.setQuoteStep("quote-done");
  }
  loading.value = false;
};
const getId = async () => {
  try {
    const cartId = await NssiData.toRemote(quote);
    return cartId;
  } catch (error) {
    console.log(error);
  }
};
const retryPersonal = async () => {
  loading.value = true;
  const result = await NssiData.issuePolicy(quote, user, getId);
  if (result.error) {
    quote.nssiPassed = false;
    quote.nssiPolicyError = result.message;
  } else {
    quote.nssiPolicyError = "";
    quote.nssiPassed = true;
    // quote.personalInsurance.orderId = result.policy.PolicyID;
    quote.personalInsurance.policyNumber = result.policy;
  }
  await checkDone();
};
function onPaymentMethodChanged(paymentMethod: PaymentMethod) {
  quote.checkout.paymentMethod.nameOnCard = paymentMethod.nameOnCard;
  quote.checkout.paymentMethod.cardNumber = paymentMethod.cardNumber;
  quote.checkout.paymentMethod.cvv = paymentMethod.cvv;
  quote.checkout.paymentMethod.expDateMonth = paymentMethod.expDateMonth;
  quote.checkout.paymentMethod.expDateYear = paymentMethod.expDateYear;
  retryPersonal();
}
function showChangePaymentInfoModal() {
  const modal = changePaymentInfo as any;
  modal.show();
}
function clearQuote() {
  quote.done = true;
}
const generateApplicationPdf = async () => {
  if (applicationPdfLink.value !== "") {
    window.open(applicationPdfLink.value);
  }
};
const generateOrderPdf = async () => {
  if (orderLink.value !== "") {
    window.open(orderLink.value);
  }
};
</script>
